import { z } from 'zod'

export const trainerAuthExceptionResponseSchema = z.record(z.unknown())
export type TrainerAuthExceptionResponse = z.infer<typeof trainerAuthExceptionResponseSchema>
